<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf" [autoScale]="false" [scale]="0.25"
    [pageWidth]="dataCategoriesV10 && dataCategoriesV10.length > 0 ? dataCategoriesV10[0].minTableWidth() : 0">    
    <!-- Tabs -->
    <tabs *ngIf="tabNames && tabNames.length > 0 && !processingTabs" [tabNames]="tabNames"
      [transformLabelsToTitleCase]="false" (selectionsChangeIndex)="selectionChange($event)"
      [startingIndex]="selectionIndex"></tabs>

    <!-- No assessment indicator -->
    <div *ngIf="tabNames && tabNames.length == 0 && !processingTabs" style="text-align: center; width: 100%" translate>
        No assessment scores exist for this student.
    </div>

    <!-- Tab Contents -->
    <!-- The contents use hidden for performance reasons, so we don't rebuild the component every time -->
    <div class="flex-content" style="height:100%;">
        <!-- Data for each tab -->
        <div [hidden]="processingTabs" *ngFor="let tab of tabs; let i = index; trackBy: tabTrackBy">

            <div>

                <!-- Only display if we're currently selected and there is data to show -->
                <div *ngIf="selectionIndex == i">

                    <!-- Displaying name of tab -->
                    <div role="heading" class="fullTitle">
                        <b *ngIf="tab.FULLTITLE != undefined && tab.FULLTITLE != ''">{{tab.DESCRIPTION}}
                            - {{tab.FULLTITLE}}</b>
                    </div>

                    <!-- Data table -->
                    <div *ngIf="tableDataV9 != null && tableDataV9.length > i">
                        <app-assessment-data-category-table *ngIf="tableDataV9[i].data.length >= 1"
                            [showChildFilters]="tab.DESCRIPTION != 'Best Of'" [data]="tableDataV9[i]" [tabIndex]="i"
                            [showActionMenu]="tab.DESCRIPTION != 'Best Of'" [triggerChanges]="triggerChanges" (getAssessmentEvent)="getAssessemntTabs($event)"></app-assessment-data-category-table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</tyl-kendo-pdf-export>
<!-- Footer -->
<div #footer [ngClass]="studentViewMode() ? 'studentViewFooter' : 'regEnrollFooter'">
    <div class="flex-footer-left">
        <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
        <tyl-button *ngIf="userCanProcess" image="add.png" label="Add Assessment" (clickEvent)="addTab()"></tyl-button>
    </div>

    <div class="flex-footer-right"></div>
</div>
